<template>
  <div class="yunxiao teacher e-wallet-prestore" data-test="e-wallet-prestore">
    <div class="main">
      <van-cell title="预存校区" title-class="abc" required is-link @click="chooseCampus">
        <template>
          <div v-if="params.campusId" >
            {{ params.campus.name }}
          </div>
          <div v-else style="color: var(--g5)">请选择</div>
        </template>
      </van-cell>
      <van-cell title="学员" title-class="abc" required is-link @click="selectStudent">
        <template>
          <div v-if="student" :style="{ color: studId ? 'var(--g6)' : 'var(--g8)' }">
            {{ student.name }}
          </div>
          <div v-else style="color: var(--g5)">请选择</div>
        </template>
      </van-cell>

      <van-field
        v-model="params.money"
        label="预存金额"
        label-class="abc"
        required
        type="number"
        input-align="right"
        placeholder="输入金额"
        :formatter="priceInputFormatter"
      >
        <template #button> 元 </template>
      </van-field>

      <!-- 整单其它信息 -->
      <template>
        <div class="separate"></div>
        <van-field
          readonly
          :right-icon="'arrow'"
          v-model="params.orderNotes"
          input-align="right"
          placeholder="请输入"
          @click.stop="updateNotes('orderNotes')">
          <template #label>
            <div @click.stop="">
              <van-popover
                v-model="pop1"
                class="popover-wrap"
                theme="dark"
                trigger="click"
                placement="top-start"
                :offset="[-8, 4]"
              >
                <div style="width: 85vw">
                  不需要家长知悉的备注信息，本机构老师可在订单详情中查看，家长端订单详情不展示
                </div>
                <template #reference>
                  备注
                  <van-icon name="question-o" class="tips-icon" />
                </template>
              </van-popover>
            </div>
          </template>
        </van-field>
        <van-field
          readonly
          :right-icon="'arrow'"
          v-model="params.buyerNotes"
          input-align="right"
          placeholder="请输入"
          @click.stop="updateNotes('buyerNotes')">
          <template #label>
            <div @click.stop="">
              <van-popover
                v-model="pop2"
                class="popover-wrap"
                theme="dark"
                trigger="click"
                placement="top-start"
                :offset="[-8, 4]"
              >
                <div style="width: 85vw">
                  需要家长知悉的备注信息，家长和本机构老师均可在订单详情中查看
                </div>
                <template #reference>
                  对外备注
                  <van-icon name="question-o" class="tips-icon" />
                </template>
              </van-popover>
            </div>
          </template>
        </van-field>
        <div class="separate"></div>
        <van-cell title="附件图片" is-link @click="uploadImg">
          <template #default>
            <span v-if="!params.attach.list.length" style="color: var(--c1)">上传图片</span>
            <span v-else>已上传{{ params.attach.list.length }}张图片</span>
          </template>
        </van-cell>
      </template>

      
      <div style="color: var(--c1); text-align: right; margin: 8px 16px;" @click="$router.push({
        name: 'help-page',
        params: {
          src:'https://bangzhu.xiaogj.com/yxhelp-list/detail-14.html'
        }
      })">什么是电子钱包预存？</div>
    </div>

    <div class="footer">
      <van-button square round block @click="cancle" data-test="e-wallet-prestore-btn-cancel">
        取消
      </van-button>
      <van-button
        square round
        block
        type="primary"
        class="right"
        @click="submitOrder"
        data-test="e-wallet-prestore-btn-submit"
      >
        提交
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'eWalletPrestore',
  data() {
    return {
      pageTitle: '费用预存',
      params: {
        studentId: '',
        campusId: app.teacher.campusId,
        campus: app.teacher.campus,
        money: '',
        orderNotes: '',
        buyerNotes: '',
        // 凭证图片
        attach: {
          list: [],
        },
      },
      student: '',
      studId: this.$route.query.id,

      pop1: false,
      pop2: false,
    };
  },
  created() {
    this.studId && this.getStudent();
  },
  inject: ['openImage'],
  methods: {
    //选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        id: this.params.campusId,
        config: {
          must: true,
        },
      });

      this.params.campusId = res.id;
      this.params.campus = res;
    },
    // 选择学员
    async selectStudent() {
      if (this.$route.query.id) {
        return false;
      }
      this.student = await app.x3.side.xsStudent({
        id: this.params.studentId,
        config: {
          enableAdd: true,
        },
        params: {
          campusIds: [this.params.campusId],
          campusList: [this.params.campus],
          status: [0, 1, 7],
        },
      });

      this.params.studentId = this.student ? this.student.id : '';
    },
    // 限制价格输入，从根本上避免用户输入不合法数据
    priceInputFormatter(newVal, regx = /^(([1-9]{1}\d{0,5})|(0{1}))(\.\d{0,2})?$/) {
      if (regx.test(newVal)) {
        return newVal;
      } else {
        return newVal.split('').slice(0, -1).join('');
      }
    },
    cancle() {
      this.$router.back();
    },
    async submitOrder() {
      if (!this.params.studentId) {
        this.$toast.fail('请选择学员');
        return false;
      }
      if (!this.params.campusId) {
        this.$toast.fail('请选择校区');
        return false;
      }
      if (!this.params.money) {
        this.$toast.fail('请输入金额');
        return false;
      }
      this.showLoading();
      let res = await this.$api.eWalletRecharge({
        ...this.params,
      });
      this.$toast.clear();
      if (res.code == 200) {
        let orderId = res.data.id;
        // 后端大佬(刘鹏)说，状态码为200时
        // 也需要判断一个是否有orderId,如果没有可能是后端有问题
        // 但后端暂时还没有找到问题具体原因，所以前端也先判断一下
        if (!orderId) {
          this.$toast('未知异常，请稍后重试');
          return false;
        }
        this.$router.push(`/sf2/${orderId}`);
      }
      if (res.code === 740000001) {
        this.$toast.clear();
        let oinfo = JSON.parse(res.msg);
        try {
          await vant.Dialog.confirm({
            message: '学员在当前校区存在【待付款】的预存订单，请前往完成支付。',
            confirmButtonText: '查看',
          });
          this.$router.push(`/orderDetail/${oinfo.orderId}/${oinfo.orderType}/${oinfo.sourceType}`);
        } catch (error) {}
        return false;
      }
      if (res.code > 60000) {
        this.$toast.fail(res.msg);
      }
    },
    async getStudent() {
      let id = this.studId;
      this.showLoading();
      if (id !== undefined) {
        try {
          // let res = await this.$api.studentGet({ id });
          let res = await this.$api.getContainFace({
            id: id,
            companyId: app.teacher.user.companyId,
          });
          if (res.code === 200) {
            this.student = res.data;
            this.params.studentId = this.student ? this.student.id : '';
            // 根据当前显示的tab,确定更新哪个请求参数加载完成状态
          }
        } catch (err) {
          console.error('获取学员详细信息出错', err);
        }
      }
      this.$toast.clear();
    },
    async updateNotes(keyName) {
      let res = await app.x3.side.xsApprovalOpinion({
        config: {
          pageTitle: keyName == 'orderNotes' ? '编辑备注' : '编辑对外备注',
        },
        field: {
          prop: keyName,
          defaultValue: this.params[keyName],
          attrs: {
            placeholder: keyName == 'orderNotes' ? '请输入备注，仅本机构老师可见' : '请输入对外备注，学员、家长和本机构老师均可见',
            showWordLimit: true,
            maxlength: 500,
            rows: 4,
            inputAlign: "left",
            clearable: true,
            autosize: true
          }
        }
      })
      this.params[keyName] = res[keyName];
    },
    async uploadImg() {
      const obj = await this.openImage(this.params.attach);
      this.params.attach = obj;
    },
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.e-wallet-prestore {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
  }
  .footer {
    height: calc(var(--w) * 50);
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    align-items: center;
    .van-button--normal.right {
      margin-left: calc(var(--gap) * 12);
    }
    .van-button {
      height: var(--cl-xs);
    }
  }
}
::v-deep .abc {
  color: var(--g7);
}

.popover-wrap {
  color: var(--g7);
  display: flex;
  align-items: center;
  .van-icon {
    margin-left: calc(var(--gap) * 2);
  }
}
</style>